var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFileGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.047,
    height: 24.067,
    viewBox: "0 0 18.047 24.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-file",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "file-regular",
    d: "M17.384,4.506,13.441.563A2.256,2.256,0,0,0,11.848-.1H2.256A2.263,2.263,0,0,0,0,2.161v19.55a2.256,2.256,0,0,0,2.256,2.256H15.791a2.256,2.256,0,0,0,2.256-2.256V6.1a2.267,2.267,0,0,0-.663-1.6ZM15.607,5.92H12.031V2.344ZM2.256,21.711V2.161H9.775V7.048A1.125,1.125,0,0,0,10.9,8.176h4.888V21.711Z",
    transform: "translate(0 0.1)",
    fill: "#146f62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFileGreen);
export default __webpack_public_path__ + "static/media/ic-file-green.e19571cce3b83194e04983c788226970.svg";
export { ForwardRef as ReactComponent };